import { Modal } from "../Modal";
import { BulkUploadFields } from "./BulkUploadFields";
import { BulkUploadModalProps } from "./models";

export const BulkUploadModal = ({
  show,
  onClose,
  onDownloadTemplate,
  onFileSelected,
  onUpload,
  onCancel,
  isParsing,
  parseError,
  showOutOfDateTemplateHint,
}: BulkUploadModalProps): JSX.Element => (
  <Modal className="BulkUploadModal" show={show} title="Bulk upload" onClose={onClose} onBackdrop={onClose}>
    <BulkUploadFields
      onDownloadTemplate={onDownloadTemplate}
      onFileSelected={onFileSelected}
      onUpload={onUpload}
      onCancel={onCancel}
      isParsing={isParsing}
      parseError={parseError}
      showOutOfDateTemplateHint={showOutOfDateTemplateHint}
    />
  </Modal>
);
